import type { ConfigName } from "../../types/config-name";

export const configName: ConfigName = "friends_and_family";
